var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-mine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 14,
    viewBox: "0 0 12.25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M11.111,5.267A1.986,1.986,0,1,1,9.125,3.313,1.97,1.97,0,0,1,11.111,5.267Zm1.312,0A3.3,3.3,0,1,1,9.125,2,3.282,3.282,0,0,1,12.423,5.267ZM7.78,10.779H10.47a3.571,3.571,0,0,1,3.468,3.665.272.272,0,0,1-.072.191.149.149,0,0,1-.11.052H4.494a.149.149,0,0,1-.11-.052.272.272,0,0,1-.072-.191A3.571,3.571,0,0,1,7.78,10.779ZM3,14.444A4.882,4.882,0,0,1,7.78,9.467H10.47a4.882,4.882,0,0,1,4.78,4.978A1.526,1.526,0,0,1,13.756,16H4.494A1.526,1.526,0,0,1,3,14.444Z",
    transform: "translate(-3 -2)",
    fill: "#373737",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMine);
export default __webpack_public_path__ + "static/media/mine.085740b1dcefaaff0ff7fe98820c9328.svg";
export { ForwardRef as ReactComponent };